import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import * as agentApi from '@api/agentApi.js';

export default {
    methods: {
        getAgentDepartmentList() {
            var Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession
            };
            $http.get('api/Agent/GetAgentDepartmentList', Params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.departmentList = Data;
                });
            });
        },
        getEmployee() {
            var Params = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession };
            $http.get("api/Department/GetDepartmentList", Params).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.TreeDataList = Data;
                });
            })
        },
        getManager(item, info) {
            if (info == "search") {
                var Params = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession, userName: item }
            } else {
                var Params = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession, deptId: item.Id };
            }

            $http.get("api/Employee/GetEmployeeByPage", Params).then(res => {
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                this.ManageData = Data;
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/components/selectStaffDialog/services.js